'use strict';
import $ from 'jquery';

export default class Gartner {
    static init() {
        $('[data-gartner-widget-id]').each((index, el) => {
            new Gartner($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        // const $target = this.el.find('.gartner-widget-target');
        GartnerPI_Widget({
            size: this.el.data('size'),
            theme: this.el.data('theme'),
            sourcingLink: "",
            widget_id: this.el.data('gartner-widget-id'),
            version: "2",
            container: this.el.get(0)
        });
    }
}